unit UHolidayList;

interface

uses
  System.Contnrs, UholidayModel, UEssentialHelper;

type
  THolidayList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    function GetItem(i: Integer): THolidayModel;
    procedure PropertyChanged;
    procedure SetValues(json: string);
    procedure SetOnPropertyChanged(const Value: TCallback);
  public
    function GetByItd(id: Integer): THolidayModel;
    procedure Add(item: THolidayModel);
    procedure GetAll(url: string; count: Integer; personalNr: string);
    property Items[i: Integer]: THolidayModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged write SetOnPropertyChanged;
  end;

implementation

uses
  WebLib.JSON, system.SysUtils, WebLib.REST, Js;

{ THolidayList }

procedure THolidayList.Add(item: THolidayModel);
begin
  inherited Add(item);
end;

procedure THolidayList.GetAll(url: string; count: Integer; personalNr: string);
var obj: TJsonObject;
    helper: string;
    client: TRestClient;
  procedure Response(sender: TObject; AResponse: string);
  var jso: TJsObject;
  begin
    jso:=TJsJson.parseObject(AResponse);
    if jso['value']<>nil then
      Self.SetValues(string(jso['value']));
    Self.PropertyChanged;
  end;
begin
  obj:=TJsonObject.Create;
  obj.AddPair('Count',IntToStr(count));
  obj.AddPair('PersonalNr',personalNr);
  helper:=obj.ToString;
  obj:=TJsonObject.Create;
  obj.AddPair('value',helper);
  client:=TRestClient.Create(nil);
  client.OnResponse:=Response;
  client.HttpsPost(url+'/HolidayService/GetAll','application/json',obj.ToString);
  client.Free;
  obj.Free;
end;

function THolidayList.GetByItd(id: Integer): THolidayModel;
var i: Integer;
    found: Boolean;
begin
  i:=0;
  found:=false;
  while not found and (i<Self.Count) do
    if Self.Items[i].Id=id then
      found:=true
    else
      Inc(i);
  if found then
    Result:=Self.Items[i]
  else
    Result:=nil;
end;

function THolidayList.GetItem(i: Integer): THolidayModel;
begin
  Result:=inherited GetItem(i) as THolidayModel;
end;

procedure THolidayList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure THolidayList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure THolidayList.SetValues(json: string);
var obj: TJsObject;
    i, count: Integer;
begin
  Self.Clear;
  obj:=TJsJson.parseObject(json);
  if obj['Count']<>nil then begin
    count:=StrToInt(string(obj['Count']));
    for i:=0 to count-1 do
      if obj['Item'+IntToStr(i)]<>nil then
        Self.Add(THolidayModel.Create(string(obj['Item'+IntToStr(i)])));
  end;
end;

end.
